import React, { useEffect, useState, useCallback } from "react";
import { Link } from "react-router-dom";
import {
    Form,
    Input,
    Select,
    Modal,
    Typography,
    Button,
    DatePicker,
    notification,
    TimePicker,
} from "antd";
import moment from "moment";
import dayjs from "dayjs";
import CoolingProcessApi from "../../Apis/CoolingProcessApi";
import ProductionApi from "../../Apis/ProductionApi";
import { AudioOutlined, InfoCircleFilled, LoadingOutlined } from "@ant-design/icons";
const { Title } = Typography;
function AddTemp({ visible, onClose, afterCookId }) {
    const [formAdd] = Form.useForm();
    const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));
    formAdd.setFieldsValue({
        productId: afterCookId?.id,
        batchCode: afterCookId?.batchCode,
        SellDate: dayjs(afterCookId?.sellByDate),
        prodTime: dayjs(afterCookId?.cookingTime, 'HH:mm'),
        unitOfMeasurement: afterCookId?.productionDTO?.unit,
    });

    const currentTime = moment().format("h:mm a");
    const [Products, setProducts] = React.useState([]);
    const getProducts = useCallback(() => {
        ProductionApi.ListProduction2()
            .then((response) => {
                setProducts(response?.payloadDto);
                console.log("option?.recipeDTO?.recipeName", response?.payloadDto);
            })
            .catch((err) => {
                console.log(err);
            });
    }, []);


    useEffect(() => {
        getProducts();
    }, [getProducts]);
    const [Correctvalid, setCorrectvalid] = useState(false);
    const handleInputChange = (event) => {
        const newItem = event.target.value.trim();
        if (newItem > 10) {
            setCorrectvalid(true)
        } else {
            setCorrectvalid(false)
        }

    };
    const handleSubmit = (data) => {

        const SelectDate = dayjs(data.createDate).format("DD/MM/YYYY");
        let formData = JSON.stringify({
            correctiveAction: Correctvalid ? data.correctiveAction : "N/A",
            temperatureTakenTime1: getCurrentUnixTimestamp(),
            temperatureInCelsius1: parseFloat(data.Temperature),
            ubd: convertToUnixTimestamp(SelectDate),
            productionDTO: {
                id: afterCookId?.id,
                batchCode: afterCookId?.batchCode,
                sellByDate: afterCookId?.sellByDate,
            },
            tenantDTO: {
                id: decodedToken?.tenantId,
                tenantApiKey: decodedToken?.tenantApiKey,
            },
        });
        console.log(formData)
        CoolingProcessApi.CreateCoolingProcess(formData)
            .then((response) => {
                notification.open({
                    message: <span style={{ fontWeight: "bold" }}>Created</span>,
                    description: "Created Successfully",
                    closeIcon: false,
                    duration: 3,
                    style: {
                        backgroundColor: "#b3ffb3",
                        color: "green",
                    },
                });
                setTimeout(() => {
                    window.location.reload();
                }, 500);
            })
            .catch((err) => {
                console.log(err);
                // Error Notification
                if (err.apiError.status) {
                    notification.open({
                        message: (
                            <span style={{ fontWeight: "bold" }}>{err.apiError.status}</span>
                        ),
                        description: err.apiError.message,
                        closeIcon: false,
                        duration: 3,
                        style: {
                            backgroundColor: "#fff2f0",
                            color: "red",
                        },
                    });
                }
            });

    };
    function convertToUnixTimestamp(dateString) {
        const parts = dateString.split("/");
        const day = parseInt(parts[0], 10);
        const month = parseInt(parts[1], 10) - 1;
        const year = parseInt(parts[2], 10);

        const unixTimestamp = Date.UTC(year, month, day);
        return unixTimestamp;
    }
    function getCurrentUnixTimestamp() {
        const currentTimeMillis = Date.now();
        const currentTimeSeconds = Math.floor(currentTimeMillis / 1000);
        return currentTimeSeconds;
    }

    const currentDate = moment().format("DD/MM/YYYY");

    const handleCancel = () => {
        formAdd.resetFields();
        onClose();
    };
    const handleInput = (e) => {
        const value = e.target.value;
        if (/^\d*\.?\d{0,2}$/.test(value)) {
            e.target.value = value;
        } else {
            // Remove any non-numeric or extra decimal characters
            e.target.value = value.slice(0, -1);
        }
    };
    const [isRecording, setIsRecording] = useState(false);
    const startRecording = (fieldN) => {

        const recognition = new window.webkitSpeechRecognition();
        recognition.lang = 'en-US';
        recognition.onresult = (event) => {
            const transcript = event.results[0][0].transcript;
            let fieldName = fieldN;

            console.log(transcript)
            formAdd.setFieldsValue({
                [fieldName]: transcript,
            });
        };

        recognition.start();
        if (fieldN === 'Temperature') {
            setIsRecording(true);
        }
    };

    const stopRecording = () => {
        setIsRecording(false);
    };
    return (
        <>
            <Modal
                footer={[]}
                width={600}
                visible={visible}
                maskClosable={false}
                onCancel={handleCancel}
                onOk={onClose}
            >
                <Title level={4} className="text-center Primary-Font mb-4 pb-3">
                    Cooling process
                </Title>
                <Form
                    form={formAdd}
                    name="nest-messages"
                    layout="horizontal"
                    labelCol={{
                        span: 9,
                    }}
                    wrapperCol={{
                        span: 15,
                    }}
                    className="FormClass IndividualProduct-Model"
                    onFinish={handleSubmit}
                >
                    <>
                        <div className="Product-createDate">
                            <Form.Item
                                name="prodTime"
                                initialValue={dayjs(currentTime, "h:mm a")}
                                className="text-lable disabled d-none"

                            >
                                <TimePicker disabled use12Hours format="h:mm a" className="form-control control-input" />
                            </Form.Item>
                            <div className="mb-3" style={{ display: 'flex', fontSize: '18px', alignItems: 'center' }}>
                                <b className="mx-2">{currentDate}</b>
                                <img
                                    src="/assest/Images/cal.png"
                                    style={{ width: '32px' }}
                                    className="logo-png"
                                />
                            </div>
                            <Form.Item
                                name="createDate"
                                initialValue={dayjs(currentDate, "DD/MM/YYYY")}
                                className="text-lable col-lg-6 col-sm-12 col-md-7 d-none"
                                rules={[
                                    {
                                        required: true,
                                        message: "Please enter Date.",
                                    },
                                ]}
                            >
                                <DatePicker
                                    format={"DD/MM/YYYY"}
                                    className="form-control control-input"
                                />
                            </Form.Item>
                        </div>
                        <Form.Item
                            name="productId"
                            label="Product Desription:"
                            className="text-lable disabled"
                            rules={[
                                {
                                    required: true,
                                    message: "Please Select Product Desription.",
                                },
                            ]}
                        >
                            <Select
                                disabled
                                className="control-Select  mb-3"
                                placeholder="Select Product Desription"
                            >
                                {Products && (
                                    <>
                                        {Products?.map((option, index) => (
                                            <option key={index} value={option?.id}>
                                                {option?.recipeDTO?.recipeName}
                                            </option>
                                        ))}
                                    </>
                                )}
                            </Select>
                        </Form.Item>
                        <Form.Item
                            name="batchCode"
                            label="Batch Code"
                            className="text-lable"
                            rules={[
                                {
                                    required: true,
                                    message: "Please enter Batch Code.",
                                },
                            ]}
                        >
                            <Input
                                type="text"
                                readOnly
                                placeholder="Batch Code"
                                className="control-input"
                            />
                        </Form.Item>



                        <Form.Item
                            name="Temperature"
                            label="Temperature"
                            className="text-lable"
                            rules={[
                                {
                                    required: true,
                                    message: "Please enter Temperature.",
                                },
                            ]}
                        >
                            <Input
                                type="number"
                                placeholder="0"
                                className="control-input col-6"
                                style={{
                                    border: 'none',
                                    textAlign: 'end',
                                    padding: '0px'
                                }}
                                addonAfter={
                                    <>
                                        <Button
                                            className="StockTempClass"
                                            style={{
                                                border: 'none',
                                                padding: 0,
                                                paddingTop: '0px',
                                                margin: 0,
                                                background: 'none',
                                                cursor: 'pointer',
                                            }}
                                        >
                                            'C
                                        </Button>
                                        <Button
                                            onMouseDown={() => startRecording('Temperature')}
                                            onMouseUp={stopRecording}
                                            onMouseLeave={stopRecording}
                                            style={{
                                                border: 'none',
                                                padding: 0,
                                                margin: 0,
                                                marginLeft: '10px',
                                                paddingLeft: '5px',
                                                paddingBottom: '5px',
                                                background: 'none',
                                                borderRadius: '0px',
                                                borderLeft: '1px solid #d9d9d9',
                                                cursor: 'pointer',
                                            }}
                                        >
                                            {isRecording ? <LoadingOutlined /> : <AudioOutlined />}
                                        </Button>
                                    </>
                                }
                            />
                        </Form.Item>

                        <Form.Item
                            name="correctiveAction"
                            label="Corrective Action"
                            className={Correctvalid ? 'text-lable' : 'd-none'}
                            rules={Correctvalid ? [
                                {
                                    required: true,
                                    message: "Please enter Temperature.",
                                },
                            ] : []}
                        >
                            <Input
                                type="text"
                                placeholder="Corrective Action"
                                className="control-input"
                            />
                        </Form.Item>





                        {/* <div className="d-flex justify-content-center pt-4">
                            <Button
                                type="primary"
                                htmlType="submit"
                                className="btn btn-primary btn-save mx-2"
                                style={{ width: "37%" }}
                            >
                                Create
                            </Button>
                            <Link
                                type="primary"
                                to={""}
                                className="btn btn-primary btn-back mx-2 w-20"
                                style={{ width: "37%" }}
                                onClick={handleCancel}
                            >
                                Cancel
                            </Link>
                        </div> */}

                        <div
                            className="d-flex justify-content-between pt-4"
                            style={{
                                gap: "10px",
                            }}
                        >
                            <Button
                                onClick={handleCancel}
                                style={{
                                    flex: 1,
                                    height: 40,
                                    borderRadius: 6,
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    color: "#000",
                                    textDecoration: "none",
                                    fontWeight: 500,
                                }}
                            >
                                Cancel
                            </Button>

                            <Button
                                type="primary"
                                htmlType="submit"
                                style={{
                                    flex: 1,
                                    height: 40,
                                    borderRadius: 6,
                                    fontWeight: 500,
                                }}
                            >
                                Save temperature
                            </Button>
                        </div>
                    </>
                </Form>
            </Modal>
        </>
    );
}

export default AddTemp;
